import React from 'react';
import PurchaseOrderPriceEntry from './PurchaseOrderPriceEntry';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles
} from '@material-ui/core';

import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import useStyles from './useStyles';
import { CapaQuotationRfqPurchaseOrder } from '@generated/graphql';

interface PurchaseOrderPriceInfoProps {
  isDesign: boolean;
  currentItem: CapaQuotationRfqPurchaseOrder | undefined;
}

const PurchaseOrderPriceInfo: React.FC<PurchaseOrderPriceInfoProps> = ({
  isDesign,
  currentItem
}) => {
  const classes = useStyles();
  const { tableHead } = useDocumentsPriceInfoStyles();

  const items = currentItem?.items ?? [];

  return (
    <div className={classes.wrapper + ' gutter'}>
      <CustomizedTypography variant="h4" fontWeight="500">
        견적 정보
      </CustomizedTypography>
      <Table>
        <TableHead className={tableHead}>
          <TableRow>
            <TableCell>
              <CustomizedTypography variant="subtitle2" color="textSecondary">
                항목
              </CustomizedTypography>
            </TableCell>
            <TableCell align="right">
              <CustomizedTypography variant="subtitle2" color="textSecondary">
                소계
              </CustomizedTypography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, index) => (
            <PurchaseOrderPriceEntry
              item={item}
              index={index}
              isDesign={isDesign}
              key={`${item?.fileId}${index}`}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default PurchaseOrderPriceInfo;

const useDocumentsPriceInfoStyles = makeStyles((theme) => ({
  tableHead: {
    '& .MuiTableCell-head': {
      padding: '8px 0px',
      fontSize: '12px',
      color: colorSet.gray700,
      borderColor: colorSet.gray200
    }
  },
  tableSubtotal: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}));
